var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',{scopedSlots:_vm._u([{key:"pageTab",fn:function(){return [_c('div',{staticClass:"libtn"},[_c('em',{staticClass:"layui-icon layui-icon-home"},[_vm._v("访问受限")])])]},proxy:true},{key:"pageContent",fn:function(){return [_c('Exception',{attrs:{"type":"403","back-text":"返回上一页"}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }